import { Box, TextField, Typography } from "@mui/material";
import useStyles from '../../../../../../styles/global-mui.js';

const SelectQuizzQuestion = ({event, onChange}) => {

    const classes = useStyles();

    return (
        <Box className="survey-form small-padding">
            <Box className='centered-wrapper'>
                <Typography variant='body1' fontWeight="bold" gutterBottom>Question du quiz</Typography>
            </Box>
            
            <TextField
                type="text"
                className={`input-field ${classes.customInput}`}
                placeholder="Saisir la question du quiz..."
                value={event.question ?? ''}
                onChange={(e) => onChange("question", e.target.value)}
            />
        </Box>
        );

}

export default SelectQuizzQuestion